import { render } from "./myapplication.vue?vue&type=template&id=f5483326&scoped=true"
import script from "./myapplication.vue?vue&type=script&lang=js"
export * from "./myapplication.vue?vue&type=script&lang=js"

import "./myapplication.vue?vue&type=style&index=0&id=f5483326&lang=scss"
import "./myapplication.vue?vue&type=style&index=1&id=f5483326&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5483326"]])

export default __exports__